import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import styles from './AddEquipmentSpecfication.module.scss';
import Loader from '../Loader/Loader'
import { Link } from 'react-router-dom';
import authHeader from '../../Services/auth-header';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { AiFillDelete } from "react-icons/ai";
import UserService from '../../Services/user-services'
import withRoutes from '../../Common/with-router'
import axios from 'axios';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

class AddEquipmentSpecfication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      setDetail: false,
      sucessPopup: false,
      uploadFileFormat: false,
      imgaeUploadPercantage: 0,
      isImageUploadDone: true,
      completeImageUpload: [],
      btndisable: true,
      fileStatus: false,
      fileUploadStatus: false,
      Categories: [
        {
          id: 1,
          name: "Putzmeister"
        },
        {
          id: 2,
          name: "Schwing"
        },
        {
          id: 3,
          name: "Other"
        }
      ],
      CategoriyId: "",
      inputs: {
        name: "",

      },
      errors: {
        name: "",
      },
      showIcon: true,
      message:"faild"

    };
  }
  componentDidMount() {
    const auth = authHeader()
    console.log("Auth Header==>", auth)
    if (auth == null) {
      return window.location.href = '/Login';
    } else {
      this.setState({
        loader: true,
        CategoriyId: this.state.Categories[0].id
      },
      ()=>{
       
      }
      )

    }


  }
  validate = (name, value) => {

    switch (name) {
      case "name":
        if (!value) {
          return "name is Required";
        } else {
          return "";
        }


      default: {
        return "";
      }
    }
  }

  handleUserInput = e => {
    this.setState({
      errors: {
        ...this.state.errors,
        [e.target.name]: this.validate(e.target.name, e.target.value.trimStart())
      },
      inputs: {
        ...this.state.inputs,
        [e.target.name]: e.target.value.trimStart()
      }
    });
  };

  handleSubmit = e => {
    const { inputs } = this.state;
    e.preventDefault();
    let validationErrors = {};
    Object.keys(inputs).forEach(name => {
      const error = this.validate(name, inputs[name]);
      if (error && error.length > 0) {
        validationErrors[name] = error;
      }
    });
    if (Object.keys(validationErrors).length > 0) {
      this.setState({ errors: validationErrors });
      return;
    } else {
      console.log("Image Count==>")
      if (this.state.completeImageUpload.length === 0) {
        this.setState({
          message:"Please Add Pdf Equipment file",
          sucessPopup: true,
        })
        // alert("Please Add Pdf")
      } else {
        let params = {
          name: this.state.inputs.name,
          link: this.state.completeImageUpload[0].uri,
          categroies: this.state.CategoriyId
        }


        UserService.eqipmentSpecficationAdd(params).then(
          response => {

            if (response.data.status === 200) {
              console.log("response==>", response)
              this.setState({
                inputs: {
                  name: ""
                },
             
                sucessPopup: true,
                message: response.data.message
               
              }, () => {
                setTimeout(() => {
                  this.props.navigate('/Equipment-specfication')
                }, 1800);
                console.log('Called', this.state)
              
              })

            } else {
              this.setState({
                loader:false
              });
            }
          },
          error => {
            console.log(error)
            this.setState({
              loader:false
            });
          }
        );

        console.log("Parmas==>", params)
        // alert("Done", params)
      }
      // window.alert("subit success");
    }

  };
  onImageChange = event => {
    console.log('PUSH==>', event.target.value)
    let text = event.target.value
    const myArray = text.split("\\").pop().split(".");
    console.log('PUSH==>', myArray[1])
    if (myArray[myArray.length-1].toLowerCase() === 'pdf') {

      this.setState({
        uploadFileFormat: false
      })
      if (event.target.files && event.target.files[0]) {
        let img = event.target.files[0];
        let formData = new FormData();
        this.setState({ btndisable: false })
        formData.append("file", img);
        let params = {
          folder: "Image",
          file: img
        }
        this.setState({
          fileStatus: true,
          btnStatus: true
        })
        return axios.post
          ('https://api.concretepumpingdepot.com//api/v1//common/uploadFile', params, {

            onUploadProgress: progressEvent =>


              this.setState({ imgaeUploadPercantage: progressEvent.progress * 100 }),
            // console.log('progres----',progressEvent.progress),
            headers: {
              "Content-Type": "multipart/form-data",

            }
          }).then(
            response => {
              console.log('REPONSE==>', response)
              if (response.data.status === 200) {

                this.setState((state) => {
                  return {
                    completeImageUpload: [{ uri: response.data.data.locationUrl, fileName: myArray[0] + "." + myArray[1], isUpload: 1 }, ...state.completeImageUpload]
                  };
                }, () => {
                  console.log('PUSH==>', this.state.completeImageUpload)
                })

                this.setState({ btnStatus: false })

              }
            })
      }
      console.log("FileFo")
    } else {
      this.setState({
        uploadFileFormat: true
      })
      console.log("dd")
    }
  }
  deleteImage = (event) => {
    this.setState({ isimaageUploadComplete: false })
    this.setState({ completeImageUpload: this.state.completeImageUpload.filter((data, index) => index !== event) })
  }
  onDocumentLoadSuccess = (event) => {
    this.setState({
      setNumPages: 1
    })
    console.log("Event==>", event)
  }
  handleChange = (event) => {
    console.log('E', event.target.value)

    this.setState({ CategoriyId: parseInt(event.target.value) }, () => {
      console.log("VALUEOFSETALL==>", this.state.CategoriyId)
    })


  };
  render() {
    const { errors } = this.state;
    return (
      <div className='main'>
        {
          this.state.loader === false ?
            <Loader /> :
            <div className='container-fluid'>
              <div className='row m=0 p-0'>
                <div className='d-flex justify-content-between customer-border align-items-center py-3 px-4 flex-wrap '>
                  <div className=''>
                    <Link to={'/Equipment-specfication'}>


                      {/* <h3 className={ "dataHeading"} style={{margin:'0px',padding:'0px'}}> */}
                      <span className='dataHeading'>
                        <span>
                          <img src='https://placing-booms-content.s3.amazonaws.com/icon/icon_1683009649845.png' className='imgarrow' alt=''></img>
                        </span>
                        Equipment Specfication
                      </span>
                    </Link>
                    {/* </h3> */}
                  </div>

                </div>
              </div>
              <div className={styles.main}>
                <div className='row'>

                  <div className='col-lg-12 col-sm-12'>
                    <div className='row'>
                      <div className='col-lg-2 col-sm-12 colsLabel'>
                        <label className={styles.labelCatagories}>
                          Name
                        </label>
                      </div>
                      <div className='col-lg-3 col-sm-12 '>
                        <input
                          type={'text'}
                          name="name"
                          className={
                            'form-control'}
                          onChange={event => this.handleUserInput(event)}
                          value={this.state.inputs.name}
                        ></input>
                        <span className="text-danger">{errors.name}</span>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-12 col-sm-12 py-4'>
                    <div className='row'>
                      <div className='col-lg-2 col-sm-12 colsLabel'>
                        <label className={styles.labelCatagories}>
                          Catagories
                        </label>
                      </div>
                      <div className='col-lg-3 col-sm-12 '>
                        <FormControl
                          className={styles.firstTextbox}
                        >
                          <Select
                            className={styles.colorWhite}
                            value={this.state.CategoriyId}
                            onChange={this.handleChange}
                            displayEmpty
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  "& .MuiMenuItem-root.Mui-selected": {
                                    backgroundColor: "#03C03C",
                                    margin: '0px 10px',
                                    borderRadius: "4px",
                                    color: 'white',

                                  },
                                  "& .MuiMenuItem-root:hover": {
                                    backgroundColor: "#03C03C",
                                    margin: '0px 10px',
                                    borderRadius: "4px",
                                    color: 'white'
                                  },
                                  "& .MuiMenuItem-root.Mui-selected:hover": {
                                    backgroundColor: "#03C03C",
                                    margin: '0px 10px',
                                    borderRadius: "4px",
                                    color: 'white'
                                  }
                                }
                              }
                            }}
                          >
                            {
                              this.state.Categories.map((data, index) => {
                                // console.log('SUB',data)
                                return (
                                  <MenuItem value={data.id} key={index}>{data.name}</MenuItem>
                                )
                              })
                            }
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                  {/* <div className='col-lg-12 col-sm-12'>
                    <div className='row'>
                      <div className='col-lg-6 col-sm-12'>
                        <div className='row'>
                          <div className='col-lg-3 col-sm-12 colsLabel'>
                            <label className={styles.labelCatagories}>
                              Name
                            </label>
                          </div>
                          <div className='col-lg-6 col-sm-12 textboxmargin'>

                            <input
                              type={'text'}
                              name="name"
                              className={
                                'form-control'}
                              onChange={event => this.handleUserInput(event)}
                                value={this.state.inputs.name}
                            ></input>
                            <span className="text-danger">{errors.name}</span>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className='col-lg-6 col-sm-12'>
                    <div className='row'>
                      <div className='col-lg-3 col-sm-12 colsLabel'>
                        <label className={styles.labelCatagories}>
                          Catagories
                        </label>
                      </div>
                      <div className='col-lg-3 col-sm-12'>
                        <FormControl
                          className={styles.firstTextbox}
                        >
                          <Select
                            className={styles.colorWhite}
                            value={this.state.CategoriyId}
                            onChange={this.handleChange}
                            displayEmpty
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  "& .MuiMenuItem-root.Mui-selected": {
                                    backgroundColor: "#03C03C",
                                    margin: '0px 10px',
                                    borderRadius: "4px",
                                    color: 'white',

                                  },
                                  "& .MuiMenuItem-root:hover": {
                                    backgroundColor: "#03C03C",
                                    margin: '0px 10px',
                                    borderRadius: "4px",
                                    color: 'white'
                                  },
                                  "& .MuiMenuItem-root.Mui-selected:hover": {
                                    backgroundColor: "#03C03C",
                                    margin: '0px 10px',
                                    borderRadius: "4px",
                                    color: 'white'
                                  }
                                }
                              }
                            }}
                          >
                            {
                              this.state.Categories.map((data, index) => {
                                // console.log('SUB',data)
                                return (
                                  <MenuItem value={data.id} key={index}>{data.name}</MenuItem>
                                )
                              })
                            }
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div> */}
<hr/>

                  <div className={styles.productdescription}>
                    <h3 className={styles.fileUpload}>
                     Equipment Pdf Files
                    </h3>
                    <div className='row m-0 p-0'>
                      <div className='col-lg-6 col-sm-12 '>
                        <div>
                          <div className={styles.imagepadding}>
                            {
                              this.state.uploadFileFormat === true ?
                                "File Format Not Supported" : ""
                            }
                          </div>
                          <div className={styles.uploadOuterV1}>

                            <div className={styles.dragBox} >
                              <img src='/imgs/uploadIcon.png' className={styles.uploadIcon} alt=''></img>
                              {/* <input type="file" onChange={this.onImageChange} disabled={this.state.fileStatus} accept="application/pdf" /> */}
                              <input type="file" onChange={this.onImageChange} disabled={this.state.fileStatus} 
                                    onClick={(e)=> {e.currentTarget.value = null}} 
                                    multiple={true}
                                    accept="application/pdf"
                                    />
                            </div>
                              <div className={styles.imgtextCenter}>
                                Drag File To upload
                              </div>

                          </div>
                        </div>
                      </div>
                      <div className='col-lg-6 col-sm-12 '>

                        <div className={styles.imgeUploadPaadding}>
                          <div className='row'>
                            {
                              this.state.completeImageUpload.map((data, index) => {
                                console.log('INDEX==>', index)
                                // console.log('Equipment',data)
                                return (

                                  <div className='col-lg-12 p-3' key={index}>
                                    <div className='row'>
                                     
                                      <div className='col-lg-2 col-sm-3 '>
                                        <a href={data.uri} target="_blank"
                                          rel="noreferrer">
                                          <img src='https://placing-booms-content.s3.us-east-2.amazonaws.com/ProductImage/ProductImage_1684670141216.jpg' className={styles.imgWidth} alt=""></img>

                                        </a>

                                      </div>
                                      <div className='col-lg-8 col-sm-7'>
                                        <span>{data.fileName}</span>
                                        <ProgressBar variant='danger' now={100} className={styles.imageProgress} />
                                        <span>Completed</span>
                                      </div>
                                      <div className='col-lg-2 col-sm-3 imgDeleteIcon'>
                                        <span>
                                          {

                                            this.state.showIcon === true ? <AiFillDelete onClick={() => this.deleteImage(index)} className={styles.closeIcon} /> : ""
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className='row'>
                    <div className='col-lg-3 col-sm-12 m-auto py-5 text-center'>
                      <button className='btn btn-success'
                        onClick={this.handleSubmit}
                        disabled={this.state.btnStatus === true ? true : false}
                      >Submit</button>




                    </div>

                    <ToastContainer className="w-100" >
                    <Toast style={{ position: "absolute", right: 0 }} onClose={() => {
                      this.setState({
                        sucessPopup: false
                      })
                    }} show={this.state.sucessPopup} delay={1500} autohide position={'bottom-end'}  >

                      <Toast.Body style={{ backgroundColor: "#00ad4d", color: 'white' }}>{this.state.message}</Toast.Body>
                    </Toast>
                  </ToastContainer>
                  </div>
                </div>
              </div>

            </div>
        }
      </div>
    )
  }
}

AddEquipmentSpecfication.propTypes = {};

AddEquipmentSpecfication.defaultProps = {};

export default withRoutes(AddEquipmentSpecfication);
